module.exports = __webpack_public_path__ + "media/images/fbcalls/coinbase-5509d828bd54ac18cf9e0d0c78425e36.jpg";